import { countryLocale, Realm } from './constants';

export const createSupportLink = (realm: Realm) => {
  switch (realm) {
    case 'de':
      return `https://support.ilteducation.de/kb/${countryLocale[realm]}`;
    case 'fi':
      return `https://support.ilteducation.fi/kb/${countryLocale[realm]}`;
    case 'fr':
      return `https://support.sondo.fr/`;
    case 'no':
      return `https://support.ilteducation.no/kb/${countryLocale[realm]}`;
    case 'nl':
      return `https://support.ilteducation.de/kb/${countryLocale[realm]}`;
    case 'se':
      return `https://support.ilteducation.se/kb/${countryLocale[realm]}`;
    case 'uk':
      return `https://support.ilteducation.co.uk/kb/${countryLocale[realm]}`;
    case 'us':
      return `https://support.ilteducation.com/kb/${countryLocale[realm]}`;
    default:
      return `https://support.ilteducation.se/kb/${countryLocale[realm]}`;
  }
};
